import { Injectable } from '@angular/core';
import { DataManagerResult, IDataState, Rest, RestService } from '@ralba/shared';
import {
  DocumentTagDto,
  TenancyRequestDto
} from '../dto';

@Injectable({ providedIn: 'root' })
export class ManageDocumentTagHttpApiService {
  constructor(private rest: RestService) { }


  public get(id: string, params: TenancyRequestDto) {
    const request: Rest.Request<TenancyRequestDto> = {
      method: 'GET',
      url: '/api/manage/document-tag/' + id,
      params,
    };
    return this.rest.request<TenancyRequestDto<{ id: string }>, Rest.AbpResponse<DocumentTagDto>>(request);
  }

  public create(body: TenancyRequestDto<DocumentTagDto>) {
    const request: Rest.Request<TenancyRequestDto<DocumentTagDto>> = {
      method: 'POST',
      url: '/api/manage/document-tag',
      body,
    };
    return this.rest.request<TenancyRequestDto<DocumentTagDto>, Rest.AbpResponse<DocumentTagDto>>(request);
  }

  public update(id: string, body: TenancyRequestDto<DocumentTagDto>) {
    const request: Rest.Request<TenancyRequestDto<DocumentTagDto>> = {
      method: 'PUT',
      url: '/api/manage/document-tag/' + id,
      body
    };
    return this.rest.request<TenancyRequestDto<DocumentTagDto>, Rest.AbpResponse<DocumentTagDto>>(request);
  }

  public delete(params: TenancyRequestDto<{ id: number }>) {
    const request: Rest.Request<TenancyRequestDto<{ id: number }>> = {
      method: 'DELETE',
      url: '/api/manage/document-tag',
      params
    };
    return this.rest.request<TenancyRequestDto<{ id: number }>, Rest.AbpResponse<void>>(request);
  }

  public dataManager(body: TenancyRequestDto<IDataState>) {
    const request: Rest.Request<TenancyRequestDto<IDataState>> = {
      method: 'POST',
      url: '/api/manage/document-tag/datamanager',
      body: {
        ...body,
        userId: body.userId,
        tenantId: body.tenantId,
      },
    };
    return this.rest.request<
      TenancyRequestDto<IDataState>,
      Rest.AbpResponse<DataManagerResult<DocumentTagDto>>
    >(request);
  }
}
